import React from 'react';
import { Typography } from "../ecosystem";

const FavoriteDrNotReferable = ({
    isMobile,
    orientation
}) => {

    const favDrNotReferableClasses = [
        'favorite-dr-not-referable-container',
        `favorite-dr-not-referable-container--${orientation}`
    ].join(' ');

    return (<div className={favDrNotReferableClasses}>
        <Typography
            type={isMobile ? "body-01" : "body-02"}
            tag="div"
            textAlign="center"
        >
            Not available for appointments
        </Typography>
    </div>);
}

export default FavoriteDrNotReferable;
